import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const MinusIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                stroke="currentColor"
                strokeWidth="0.75"
                d="M6 11.625h12"
            />
        </svg>
    </IconWrapper>
));
